/**
 * Guest-facing payment rules (customer contract). One answer to "does this order
 * still owe money?" for every surface: the web tracker, Chow web and the app.
 *
 * Deliberately a deny-list of SETTLED states, not an allow-list of unpaid ones:
 * the engine grows new unpaid states (`awaiting_payment`, `partial`, `failed`,
 * `pending`…) and an allow-list silently hid the Pay button for each new one.
 * The app's own check did exactly that: it matched only 'unpaid', so a
 * group order in `awaiting_payment` showed no way to pay (2026-10-09).
 */
const SETTLED_PAYMENT_STATES: ReadonlySet<string> = new Set(['paid', 'settled', 'confirmed', 'refunded', 'waived', 'comped']);

export function isUnpaidPaymentStatus(status: string | null | undefined): boolean {
  if (!status) return false;
  return !SETTLED_PAYMENT_STATES.has(status.toLowerCase());
}

/** Order states after which nobody should be asked to pay through the app. */
const CLOSED_ORDER_STATES: ReadonlySet<string> = new Set(['cancelled', 'refunded', 'void', 'voided', 'rejected']);

/** Show a "Pay now" action: money is owed and the order is still alive. */
export function shouldOfferPayment(order: { status?: string | null; paymentStatus?: string | null }): boolean {
  if (order.status && CLOSED_ORDER_STATES.has(order.status.toLowerCase())) return false;
  return isUnpaidPaymentStatus(order.paymentStatus);
}
